import axios from "axios";
import { getVoltronBase } from "../utils/helpers";

export const getPreferences = (idToken, email, locale) => {
  return axios
    .get(`${getVoltronBase()}${PREFERENCES_ENDPOINT}`, {
      params: {
        email,
      },
      data: {},
      headers: {
        idtoken: idToken,
        "content-type": "application/json",
      },
    })
    .then((response) => response.data);
};
